import React from 'react';
import 'semantic-ui-css/semantic.min.css';
import ReportModelBase from '../ReportModelBase';
import { Table } from 'semantic-ui-react';

class HDMFContributionSummaryReport extends ReportModelBase {

    constructor(props){
        super(props);
        this.searchUrl = "api/Reports/createHDMFContributionSummaryReport";
        this.title = "HDMF Contribution Summary Report";
        this.exportToExcelUrl = "api/Reports/ExportHDMFContributionSummaryReportToExcel";
        this.exportToExcelDataUrl = "api/Reports/createExportHDMFContributionSummaryReportToExcel";
        this.exportToPdfUrl = "api/Reports/createHDMFContributionSummaryReportToPDF";
    }

    toTableRow = (rowData) => {
        return (
            <Table.Row>
                <Table.Cell>{rowData.HDMFNo}</Table.Cell>
                <Table.Cell>{rowData.EmployeeNo}</Table.Cell>
                <Table.Cell>{rowData.LastName}</Table.Cell>
                <Table.Cell>{rowData.FirstName}</Table.Cell>
                <Table.Cell>{rowData.MInitial}</Table.Cell>
                <Table.Cell>{rowData.GrossIncome}</Table.Cell>
                <Table.Cell>{rowData.HDMFEE}</Table.Cell>
                <Table.Cell>{rowData.HDMFER}</Table.Cell>
                <Table.Cell>{rowData.TINNumber}</Table.Cell>
                <Table.Cell>{rowData.BirthDate}</Table.Cell>
            </Table.Row>
        );
    }

    createColumnHeaders = () => {
        return (
            <Table.Row>
                <Table.HeaderCell>HDMF No</Table.HeaderCell>
                <Table.HeaderCell>Emp No</Table.HeaderCell>
                <Table.HeaderCell>Last Name</Table.HeaderCell>
                <Table.HeaderCell>First Name</Table.HeaderCell>
                <Table.HeaderCell>M. Initial</Table.HeaderCell>
                <Table.HeaderCell>Gross Income</Table.HeaderCell>
                <Table.HeaderCell>Amount of Loan</Table.HeaderCell>
                <Table.HeaderCell>HDMF ER Contribution</Table.HeaderCell>
                <Table.HeaderCell>TIN Number</Table.HeaderCell>
                <Table.HeaderCell>Birthday</Table.HeaderCell>
            </Table.Row>
        );
    }

}

export default HDMFContributionSummaryReport;